<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <div *ngIf="data.message" [innerHtml]="data.message"></div>
    <div *ngFor="let valueItem of data.values" class="sb-confirmation-content">
        <div class="sb-confirmation-key">{{ valueItem.label }}:</div>
        <div class="sb-confirmation-value">{{ valueItem.formattedValue }}</div>
    </div>
</div>
<div mat-dialog-actions>
    <button class="btn secondary" type="button" [mat-dialog-close]="false">
        {{ data.cancelText }}
    </button>
    <button
        class="btn primary ms-3"
        type="button"
        [mat-dialog-close]="true"
        cdkFocusInitial
    >
        {{ data.confirmText }}
    </button>
</div>
